module.exports = (callback) => {
    callback = callback || function () {};
    if (document.readyState == "loading") {
        $(window).on('load', callback);
    } else {
        callback();
    }
};
